import React from 'react';
import CtaPrimary from '../../components/buttons/CtaPrimaryFullWidthMobile';
import CtaSecondaryRight from '../../components/buttons/CtaSecondaryRight';
import BgImgWhiteCorner from './BgImgWhiteCorner';
import SectionHeader from './SectionHeader';
import ValuePropsModule from './ValuePropsModule';
import RightTextToCard from './RightTextToCard';
import TinderCardBanner from './TinderCardBanner';

const unavailableProductValues = {
  rugSwipe: {
    title: 'Find Your Match!',
  },
  popularCollections: [
    {
      href: '/collections/moroccan-rugs',
      img: '//cdn.shopify.com/s/files/1/0268/0337/2125/files/Rectangle_410.jpg?v=1593105682',
      text: 'Moroccan',
    },
    {
      href: '/collections/bohemian-rugs',
      img: '//cdn.shopify.com/s/files/1/0268/0337/2125/files/Rectangle_411.jpg?v=1593105811',
      text: 'Bohemian',
    },
    {
      href: '/collections/folk-heritage-rugs',
      img: '//cdn.shopify.com/s/files/1/0268/0337/2125/files/Rectangle_412.jpg?v=1593105826',
      text: 'Folk Heritage',
    },
    {
      href: '/collections/contemporary-modern-rugs',
      img: '//cdn.shopify.com/s/files/1/0268/0337/2125/files/Rectangle_413.jpg?v=1593107563',
      text: 'Contemporary',
    },
  ],
  valueProps: [
    {
      img: '//cdn.shopify.com/s/files/1/0268/0337/2125/files/g12.jpg?v=1589921914',
      alt: 'Washing Machine',
      title: 'Machine Washable',
      description: 'Our rugs trap fewer allergens and can be easily washed at home.',
    },
    {
      img: '//cdn.shopify.com/s/files/1/0268/0337/2125/files/g12_2.jpg?v=1593108955',
      alt: 'Interchangeable Icon',
      title: 'Interchangeable',
      description: 'Switch Rug Covers as often as you like using any same-size Ruggable Rug Pad.',
    },
    {
      img: '//cdn.shopify.com/s/files/1/0268/0337/2125/files/g12_1.jpg?v=1589922170',
      alt: 'Nonslip Icon of Sneaker',
      title: 'Nonslip',
      description: 'Our Rug Pad is extra grippy, which means that it will stay put, no matter what.',
    },
    {
      img: '//cdn.shopify.com/s/files/1/0268/0337/2125/files/WaterResistant.jpg?v=1594331805',
      alt: 'Water Droplet Icon',
      title: 'Water Resistant',
      description: 'Our rugs are water-resistant, so it’s much easier to spot-clean minor spills.',
    },
  ],
  rugColors: [
    {
      title: 'Grey & Silver Rugs',
      titleIcon: '//cdn.shopify.com/s/files/1/0268/0337/2125/files/color-grey-silver.jpg?v=1594339806',
      iconAlt: 'Grey & Silver Icon',
      description: 'Whether it’s cool silver or warm ash grey, you can never go wrong with a grey rug.',
      buttonText: 'Shop Grey & Silver Rugs',
      img: '//cdn.shopify.com/s/files/1/0268/0337/2125/files/main_img.jpg?v=1593113352',
      href: '/collections/grey-silver-rugs',
      insertCta: 'secondary',
    },
    {
      title: 'Blue & Green Rugs',
      titleIcon: '//cdn.shopify.com/s/files/1/0268/0337/2125/files/color-blue-green.jpg?v=1594339805',
      iconAlt: 'Blue & Green Icon',
      description: window.geoLocale.location === 'en-GB' ? 'Blue and green rugs usually draw inspiration from the colours of nature.' : 'Blue and green rugs usually draw inspiration from the colors of nature.',
      buttonText: 'Shop Blue & Green Rugs',
      img: '//cdn.shopify.com/s/files/1/0268/0337/2125/files/bluegreen_thumb_df6a81e9-b213-4b4c-9714-ea13551762ec.jpg?v=1594843386',
      href: '/collections/blue-green-rugs',
      insertCta: 'secondary',
    },
    {
      title: 'White & Cream Rugs',
      titleIcon: '//cdn.shopify.com/s/files/1/0268/0337/2125/files/color-white-cream.jpg?v=1594339805',
      iconAlt: 'White & Cream Icon',
      description: window.geoLocale.location === 'en-GB' ? 'These rugs not only flatter the whole spectrum of colours but can also make a space look roomier.' : 'These rugs not only flatter the whole spectrum of colors but can also make a space look roomier.',
      buttonText: 'Shop White & Cream Rugs',
      img: '//cdn.shopify.com/s/files/1/0268/0337/2125/files/main_img_2.jpg?v=1593119858',
      href: '/collections/white-cream-rugs',
      insertCta: 'secondary',
    },
    {
      title: 'Natural Rugs',
      titleIcon: '//cdn.shopify.com/s/files/1/0268/0337/2125/files/colo-natural.jpg?v=1594339805',
      iconAlt: 'Natural Color Icon',
      description: 'These subtle-toned rugs fit perfectly in any style you choose and add an understated elegance.',
      buttonText: 'Shop Natural Rugs',
      img: '//cdn.shopify.com/s/files/1/0268/0337/2125/files/main_img_3.jpg?v=1593119893',
      href: '/collections/natural-neutral-rugs',
      insertCta: 'secondary',
    },
  ],
  sizeGuide: {
    title: 'Rug Size Guide',
    description:
      'Looking for the best rug size for your space? Here we asked the experts on how to pick the right size of rug for each room in your house.',
    insertCta: 'secondary',
    buttonText: 'Learn More',
    href: '/pages/rug-sizes',
    img: '//cdn.shopify.com/s/files/1/0268/0337/2125/files/Hero_Desktop.jpg?v=1576024642',
    desktopImg: '//cdn.shopify.com/s/files/1/0268/0337/2125/files/Hero_Desktop.jpg?v=1576024642',
    mobileImg: '//cdn.shopify.com/s/files/1/0268/0337/2125/files/image_27.jpg?v=1593121423',
    mobileDesktop: true,
  },
};

const popularCollectionItems = unavailableProductValues.popularCollections.map((popularCollectionItem, i) => {
  return (
    <BgImgWhiteCorner
      text={popularCollectionItem.text}
      href={popularCollectionItem.href}
      img={popularCollectionItem.img}
    />
  );
});

const rugColorCollections = unavailableProductValues.rugColors.map((rugColorCollection, i) => {
  return (
    <RightTextToCard
      buttonText={rugColorCollection.buttonText}
      href={rugColorCollection.href}
      img={rugColorCollection.img}
      description={rugColorCollection.description}
      title={rugColorCollection.title}
      icon={rugColorCollection.titleIcon}
      iconAlt={rugColorCollection.iconAlt}
      insertCta={rugColorCollection.insertCta}
    />
  );
});

const unavailableProduct = () => {
  return (
    <div className='unavailableProductContainer'>
      <div className='header'>
        <h1>Style Not Available</h1>
        <p className='desktop-tablet'>
          Looks like the rug you like is no longer available. The good news? <br />
          We've got lots of shopper-favorite rug styles you might also like!
        </p>
        <p className='mobile'>Looks like the rug you like is no longer available.</p>
        <CtaPrimary text='Shop Best Sellers' href='/collections/best-sellers'/>
      </div>
      <div className='rug-swipe'>
        <div className='mobile-swipe-description'>
          <h3>The Good News?</h3>
          <p>We've got lots of shopper-favorite rug styles you might also like!</p>
        </div>
        <TinderCardBanner title={unavailableProductValues.rugSwipe.title} />
      </div>
      <div className='popular-collections'>
        <SectionHeader title='Popular Collections' />
        <div className='popular-collections-grid'>{popularCollectionItems}</div>
        <CtaPrimary text='Shop All Collections' href='/pages/all-rug-collections' />
      </div>
      <ValuePropsModule itemData={unavailableProductValues.valueProps} />
      <div className='rug-color-collections'>
      {window.geoLocale.location === 'en-GB' ?
          <SectionHeader title='Our Top Rug Colours' />
          :
          <SectionHeader title='Our Top Rug Colors' />
           }
        <div className='rug-colors-grid'>{rugColorCollections}</div>
        <div className='btn-wrapper'>
          {window.geoLocale.location === 'en-GB' ?
          <CtaPrimary text='Shop All Colours' href='/pages/all-rug-colors' />
          :
          <CtaPrimary text='Shop All Colors' href='/pages/all-rug-colors' />
           }
        </div>
      </div>
      <div className='rug-size-guide'>
        <h2>{unavailableProductValues.sizeGuide.title}</h2>
        <p>{unavailableProductValues.sizeGuide.description}</p>
        <CtaSecondaryRight
          href={unavailableProductValues.sizeGuide.href}
          text={unavailableProductValues.sizeGuide.buttonText}
        />
      </div>
      {window.geoLocale.location === 'en-US' && (
        <div className='hash-my-ruggable'>
          <h2>#Ruggable In Real Life</h2>
          <p>Need inspiration? See how shoppers like you style their Ruggable rugs.</p>
          <div className='pdp-curalate' crl8-container-id='product'></div>
          <CtaPrimary text='Shop Our Instagram' href='/pages/instagram-shop' />
        </div>
      )}
    </div>
  );
};

export default unavailableProduct;
